import AddAdditionalExpenseRequest from "@/models/server/requests/AddAdditionalExpenseRequest";

export default class SaveAdditionalExpenseRequest extends AddAdditionalExpenseRequest {
    public id: string = "";
}